import { useSiteSettings } from '@/hooks/useSiteSettings';
import { resolveSlotImage } from '@/lib/siteImages';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  image?: string;
  slot?: string;
  breadcrumb?: string;
}

export default function PageHero({ title, subtitle, image = '', slot, breadcrumb }: PageHeroProps) {
  const { data } = useSiteSettings();
  const src = slot ? resolveSlotImage(data, slot, image) : image;

  return (
    <section className="relative h-[380px] md:h-[480px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={src}
          alt={title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1200px] mx-auto px-4 md:px-8 w-full">
        {breadcrumb && (
          <p className="text-accent-400 font-label text-xs tracking-widest uppercase mb-3 flex items-center gap-2">
            <i className="ri-home-line" aria-hidden="true" />
            <span>Home</span>
            <i className="ri-arrow-right-s-line" aria-hidden="true" />
            <span>{breadcrumb}</span>
          </p>
        )}
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight max-w-2xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/80 text-base md:text-lg mt-4 max-w-xl leading-relaxed">
            {subtitle}
          </p>
        )}
        <div className="w-16 h-1 bg-accent-500 mt-6" />
      </div>
    </section>
  );
}